import {clsx} from 'clsx'

import styles from './borderless-text-input.module.css'

type StyledBorderLessTextInputProps = React.InputHTMLAttributes<HTMLInputElement> & {ref?: React.Ref<HTMLInputElement>}

export function BorderlessTextInput({ref: forwardedRef, className, ...props}: StyledBorderLessTextInputProps) {
  // A solution to make this component work without the interference of the wrapper of Primer's `TextInput`
  return <input {...props} ref={forwardedRef} className={clsx(styles.Box, className)} />
}

BorderlessTextInput.displayName = 'BorderlessTextInput'
